import { SiteMetadata } from "./s3";

interface ResolveSiteIdentityParams {
  metadata?: SiteMetadata | null;
  channelData?: { id?: string | null } | null;
}

export interface SiteIdentity {
  accountId: string | undefined;
  siteId: string | undefined;
}

export function resolveSiteIdentity({
  metadata,
  channelData,
}: ResolveSiteIdentityParams): SiteIdentity {
  return {
    accountId: metadata?.accountId ?? undefined,
    siteId: channelData?.id ?? undefined,
  };
}
